import {findConjugationSiteCandidates} from 'molbio/adcs/conjugation-sites/findConjugationSiteCandidates';
import makeCustomResolutionResultFromTypedValue from 'notebook/integrations/samples/transfer-table-columns/makeCustomResolutionResultFromTypedValue';
import {
  RegistrationTableAdcConjugationSiteCandidatesQuery,
  ServerResolutionResult,
} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {BaseTypedValueType} from 'notebook/tables/typed-values/TypedValueConstants';

/**
 * Resolves an antibody's candidate conjugation sites for a method to a JSON typed value holding a
 * `ConjugationSiteCandidatesResult`, so table custom evals can read them through the resolution cache.
 */
export default async function resolveConjugationSiteCandidates({
  antibodyId,
  conjugationMethod,
}: RegistrationTableAdcConjugationSiteCandidatesQuery): Promise<ServerResolutionResult> {
  const result = await findConjugationSiteCandidates({antibodyId, conjugationMethod});
  return makeCustomResolutionResultFromTypedValue({type: BaseTypedValueType.JSON, jsonValue: result});
}
